<mat-tab-group mat-stretch-tabs>
    <mat-tab label="{{ 'Modules.ServiceComponent.List.Stores.TabHeader' | translate }}"  *ngIf="('devices' | hasPermission :'Device':'read' | async)">
        <ng-template matTabContent>
            <xpac-remote-maintenance></xpac-remote-maintenance>
        </ng-template>
    </mat-tab>
    <mat-tab label="{{ 'Modules.ServiceComponent.List.Update.TabHeader' | translate }}" *ngIf="('devices' | hasPermission :'Mender_Artifacts':'read' | async)">
        <ng-template matTabContent>
            <xpac-remote-device-update></xpac-remote-device-update>
        </ng-template>
    </mat-tab>
    <mat-tab label="{{ 'Modules.ServiceComponent.List.Map.TabHeader' | translate }}" *ngIf="('devices' | hasPermission :'Device':'read' | async)">
        <ng-template matTabContent>
            <xpac-map-view></xpac-map-view>
        </ng-template>
    </mat-tab>
</mat-tab-group>